(ns ui.hyperframes-templates.composition
  "Shows a template clip on the editor2 stage with the player. The
   element id follows the `<asset-type>-<clip-uuid>` convention of
   `ui.editor2.actions/seek-video!`, so the seek, play and pause of
   editor2 reach the player like a <video> element."
  (:require [ui.editor2.actions :as actions]
            [ui.editor2.extension-points :as extension-points]
            [ui.hyperframes-templates.player :as player]))

(defn seek-when-ready
  "Seeks the player to the playhead once its composition has loaded.
   A player mounts after `seek!` ran (a fresh clip, a reload after a
   variable change), and a seek before `ready` is lost."
  [state clip]
  (fn [{:keys [replicant/node]}]
    (.addEventListener node
                       "ready"
                       (fn [_]
                         (actions/seek-video! {:state state
                                               :clip clip})))))

(defmethod extension-points/composition-asset :hyperframes
  [{:keys [clip state]}]
  (let [asset (:clip/asset clip)
        data (:asset/data asset)]
    (player/element {:id (str "hyperframes-" (:clip/uuid clip))
                     :template-id (:hyperframes/template-id data)
                     :variables (:hyperframes/variables data)
                     :width (:asset/width asset)
                     :height (:asset/height asset)
                     :on-mount (seek-when-ready state clip)
                     :style {:display "block"
                             :width "100%"
                             :height "100%"
                             :pointer-events "none"}})))

(defmethod extension-points/asset-thumbnail :hyperframes
  [_params]
  nil)
